import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { useCurrentSong } from '../hooks/useCurrentSong';
import MarqueeText from '../components/MarqueeText';
import api from '../api/api';

export default function Widget() {
  const { uuid } = useParams();
  const { song } = useCurrentSong(uuid);
  const [cfg, setCfg] = useState(null);

  useEffect(() => {
    api.get(`/widget/public/${uuid}`).then((r) => setCfg(r.data.config)).catch(() => {});
  }, [uuid]);

  useEffect(() => {
    document.body.style.background = 'transparent';
    document.body.style.margin = '0';
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.background = '';
    };
  }, []);

  const isPlaying = song?.is_playing;

  if (!isPlaying || !cfg) {
    return null;
  }

  const {
    transparent_bg = true,
    bg_color = '#1a1a2e',
    bg_opacity = 100,
    text_color = '#ffffff',
    accent_color = '#1db954',
    font = 'Inter',
    font_size = 16,
    show_cover = true,
    scroll = true,
    scroll_speed = 40,
    layout = 'horizontal',
    width = 400,
    height = 80,
    show_progress = true,
    show_artist = true,
  } = cfg;

  const hexToRgba = (hex, opacity) => {
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${opacity / 100})`;
  };

  const fmt = (ms) => {
    const s = Math.floor(ms / 1000);
    return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
  };

  const progress = song.duration_ms > 0
    ? (song.progress_ms / song.duration_ms) * 100
    : 0;

  return (
    <div
      style={{
        display: 'flex',
        alignItems: layout === 'horizontal' ? 'center' : 'flex-start',
        flexDirection: layout === 'vertical' ? 'column' : 'row',
        gap: 12,
        padding: '8px 12px',
        fontFamily: `${font}, sans-serif`,
        fontSize: font_size,
        color: text_color,
        background: transparent_bg ? 'transparent' : hexToRgba(bg_color, bg_opacity),
        width,
        height,
        borderRadius: 8,
        boxSizing: 'border-box',
        overflow: 'hidden',
      }}
    >
      {show_cover && song.cover_url && (
        <img
          src={song.cover_url}
          alt=""
          style={{ width: height * 0.75, height: height * 0.75, borderRadius: 6, objectFit: 'cover', flexShrink: 0 }}
        />
      )}
      <div style={{ flex: 1, minWidth: 0 }}>
        {scroll ? (
          <MarqueeText speed={scroll_speed} style={{ fontWeight: 600 }}>
            {song.title}
          </MarqueeText>
        ) : (
          <div style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontWeight: 600 }}>
            {song.title}
          </div>
        )}
        {show_artist && (
          scroll ? (
            <MarqueeText
              speed={scroll_speed}
              style={{ color: accent_color, fontSize: font_size * 0.75 }}
            >
              {song.artist}
            </MarqueeText>
          ) : (
            <div style={{ color: accent_color, fontSize: font_size * 0.75, overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
              {song.artist}
            </div>
          )
        )}
        {show_progress && (
          <>
            <div style={{ marginTop: 4, height: 3, background: 'rgba(255,255,255,0.2)', borderRadius: 2 }}>
              <div style={{ width: `${progress}%`, height: '100%', background: accent_color, borderRadius: 2, transition: 'width 1s linear' }} />
            </div>
            <div style={{ fontSize: font_size * 0.6, color: 'rgba(255,255,255,0.5)', marginTop: 2, display: 'flex', justifyContent: 'space-between' }}>
              <span>{fmt(song.progress_ms)}</span>
              <span>{fmt(song.duration_ms)}</span>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
